<template>
    <div>
        <FormKit
            type="hidden"
            :name="`components[${index}][component_type]`"
            :value="component.component_type"
        />

        <FormKit
            label="Achtergrondkleur"
            type="color"
            :name="`components[${index}][background_color]`"
            :value="component.background_color"
            @input="(value) => update('background_color', value)"
        />

        <hr />

        <!-- Block 1 -->
        <div class="border p-4 mb-4 rounded">
            <h4 class="font-weight-bold mb-3">Block 1</h4>
            
            <FormKit
                label="Block 1 Titel"
                type="text"
                :name="`components[${index}][blocks][0][title]`"
                v-model="blocks[0].title"
            />

            <!-- Block 1 Column 1 -->
            <div class="mt-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <span class="font-weight-bold">Kolom 1</span>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary" @click="addLink(0, 0)">
                            Add Link
                        </button>
                    </div>
                </div>

                <Draggable v-model="blocks[0].lists[0]" handle=".link-drag-handle" item-key="id" :key="getBlockListKey(0, 0)">
                    <template #item="{ element: link, index: linkIndex }">
                        <div class="border-top py-4">
                            <div class="mb-2 d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                    <i class="las la-grip-vertical mr-2 text-muted link-drag-handle" style="cursor: grab;"></i>
                                    <span class="font-weight-bold">Link #{{ linkIndex + 1 }}</span>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="removeLink(0, 0, linkIndex)"
                                    >
                                        <i class="lar la-trash-alt mr-2"></i>
                                    </button>
                                </div>
                            </div>

                            <FormKit
                                label="Link Tekst"
                                type="text"
                                :name="`components[${index}][blocks][0][lists][0][${linkIndex}][text]`"
                                v-model="link.text"
                            />
                            <FormKit
                                label="Link URL"
                                type="text"
                                :name="`components[${index}][blocks][0][lists][0][${linkIndex}][url]`"
                                v-model="link.url"
                            />
                        </div>
                    </template>
                </Draggable>
            </div>

            <!-- Block 1 Column 2 -->
            <div class="mt-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <span class="font-weight-bold">Kolom 2</span>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary" @click="addLink(0, 1)">
                            Add Link
                        </button>
                    </div>
                </div>

                <Draggable v-model="blocks[0].lists[1]" handle=".link-drag-handle" item-key="id" :key="getBlockListKey(0, 1)">
                    <template #item="{ element: link, index: linkIndex }">
                        <div class="border-top py-4">
                            <div class="mb-2 d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                    <i class="las la-grip-vertical mr-2 text-muted link-drag-handle" style="cursor: grab;"></i>
                                    <span class="font-weight-bold">Link #{{ linkIndex + 1 }}</span>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="removeLink(0, 1, linkIndex)"
                                    >
                                        <i class="lar la-trash-alt mr-2"></i>
                                    </button>
                                </div>
                            </div>

                            <FormKit
                                label="Link Tekst"
                                type="text"
                                :name="`components[${index}][blocks][0][lists][1][${linkIndex}][text]`"
                                v-model="link.text"
                            />
                            <FormKit
                                label="Link URL"
                                type="text"
                                :name="`components[${index}][blocks][0][lists][1][${linkIndex}][url]`"
                                v-model="link.url"
                            />
                        </div>
                    </template>
                </Draggable>
            </div>
        </div>

        <!-- Block 2 -->
        <div class="border p-4 mb-4 rounded">
            <h4 class="font-weight-bold mb-3">Block 2</h4>
            
            <FormKit
                label="Block 2 Titel"
                type="text"
                :name="`components[${index}][blocks][1][title]`"
                v-model="blocks[1].title"
            />

            <!-- Block 2 Column 1 -->
            <div class="mt-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <span class="font-weight-bold">Kolom 1</span>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary" @click="addLink(1, 0)">
                            Add Link
                        </button>
                    </div>
                </div>

                <Draggable v-model="blocks[1].lists[0]" handle=".link-drag-handle" item-key="id" :key="getBlockListKey(1, 0)">
                    <template #item="{ element: link, index: linkIndex }">
                        <div class="border-top py-4">
                            <div class="mb-2 d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                    <i class="las la-grip-vertical mr-2 text-muted link-drag-handle" style="cursor: grab;"></i>
                                    <span class="font-weight-bold">Link #{{ linkIndex + 1 }}</span>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="removeLink(1, 0, linkIndex)"
                                    >
                                        <i class="lar la-trash-alt mr-2"></i>
                                    </button>
                                </div>
                            </div>

                            <FormKit
                                label="Link Tekst"
                                type="text"
                                :name="`components[${index}][blocks][1][lists][0][${linkIndex}][text]`"
                                v-model="link.text"
                            />
                            <FormKit
                                label="Link URL"
                                type="text"
                                :name="`components[${index}][blocks][1][lists][0][${linkIndex}][url]`"
                                v-model="link.url"
                            />
                        </div>
                    </template>
                </Draggable>
            </div>

            <!-- Block 2 Column 2 -->
            <div class="mt-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <span class="font-weight-bold">Kolom 2</span>
                    </div>
                    <div>
                        <button type="button" class="btn btn-primary" @click="addLink(1, 1)">
                            Add Link
                        </button>
                    </div>
                </div>

                <Draggable v-model="blocks[1].lists[1]" handle=".link-drag-handle" item-key="id" :key="getBlockListKey(1, 1)">
                    <template #item="{ element: link, index: linkIndex }">
                        <div class="border-top py-4">
                            <div class="mb-2 d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                    <i class="las la-grip-vertical mr-2 text-muted link-drag-handle" style="cursor: grab;"></i>
                                    <span class="font-weight-bold">Link #{{ linkIndex + 1 }}</span>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-danger"
                                        @click="removeLink(1, 1, linkIndex)"
                                    >
                                        <i class="lar la-trash-alt mr-2"></i>
                                    </button>
                                </div>
                            </div>

                            <FormKit
                                label="Link Tekst"
                                type="text"
                                :name="`components[${index}][blocks][1][lists][1][${linkIndex}][text]`"
                                v-model="link.text"
                            />
                            <FormKit
                                label="Link URL"
                                type="text"
                                :name="`components[${index}][blocks][1][lists][1][${linkIndex}][url]`"
                                v-model="link.url"
                            />
                        </div>
                    </template>
                </Draggable>
            </div>
        </div>
    </div>
</template>

<script>
import mixin from "../mixins/component";
import Draggable from "vuedraggable";

export default {
    name: "PageLinks",
    mixins: [mixin],
    components: {
        Draggable,
    },
    data() {
        // Initialize blocks array with proper ID handling
        const initializeLinks = (links) => {
            if (!links || !Array.isArray(links)) {
                return [{ id: `link_${Date.now()}_${Math.random()}`, text: "", url: "" }];
            }
            return links.map(link => ({
                ...link,
                id: link.id || `link_${Date.now()}_${Math.random()}`
            }));
        };

        const initializeBlocks = (blocks) => {
            // Always ensure exactly 2 blocks, each with 2 lists
            const defaultBlocks = [
                {
                    id: `block_${Date.now()}_${Math.random()}`,
                    title: "",
                    lists: [
                        initializeLinks([]),
                        initializeLinks([])
                    ]
                },
                {
                    id: `block_${Date.now()}_${Math.random() + 1}`,
                    title: "",
                    lists: [
                        initializeLinks([]),
                        initializeLinks([])
                    ]
                }
            ];

            if (!blocks || !Array.isArray(blocks)) {
                return defaultBlocks;
            }

            // Ensure we have exactly 2 blocks, fill missing ones with defaults
            const result = [];
            for (let i = 0; i < 2; i++) {
                if (blocks[i]) {
                    result[i] = {
                        ...blocks[i],
                        id: blocks[i].id || `block_${Date.now()}_${i}`,
                        lists: [
                            initializeLinks(blocks[i].lists?.[0] || []),
                            initializeLinks(blocks[i].lists?.[1] || [])
                        ]
                    };
                } else {
                    result[i] = defaultBlocks[i];
                }
            }
            return result;
        };

        let blocks = initializeBlocks(this.modelValue?.blocks);

        return {
            blocks,
        };
    },
    computed: {
        blocksKey() {
            return this.blocks.map(block => block.id).join('-');
        },
    },
    mounted() {
        // Ensure the blocks are initialized
        if (!this.modelValue?.blocks) {
            this.update("blocks", this.blocks);
        }
    },
    methods: {
        addLink(blockIndex, listIndex) {
            this.blocks[blockIndex].lists[listIndex].push({
                id: `link_${Date.now()}_${Math.random()}`,
                text: "",
                url: ""
            });
        },
        removeLink(blockIndex, listIndex, linkIndex) {
            this.blocks[blockIndex].lists[listIndex].splice(linkIndex, 1);
        },
        getBlockListKey(blockIndex, listIndex) {
            return this.blocks[blockIndex]?.lists?.[listIndex]?.map(link => link.id).join('-') || '';
        }
    },
    watch: {
        blocks: {
            deep: true,
            handler(blocks) {
                this.update("blocks", blocks);
            },
        },
    },
};
</script>
